const target = new EventTarget();
const listeners = new Map();

export default {
	subscribe(event, callback) {
		const wrapper = (e) => callback(e.detail);

		if (!listeners.has(callback)) {
			listeners.set(callback, new Map());
		}

		listeners.get(callback).set(event, wrapper);

		target.addEventListener(event, wrapper);
	},

	unsubscribe(event, callback) {
		const eventMap = listeners.get(callback);

		if (!eventMap) return;

		const wrapper = eventMap.get(event);

		if (wrapper) {
			target.removeEventListener(event, wrapper);
			eventMap.delete(event);

			if (eventMap.size === 0) {
				listeners.delete(callback);
			}
		}
	},

	emit(event, data) {
		target.dispatchEvent(new CustomEvent(event, { detail: data }));
	},
};
